import { useSubscription } from './use-subscription'

/**
 * Returns the numeric limit for a given limit_key on the tenant's current plan.
 *
 * @returns
 *   - `limit`: the numeric limit, or `null` if no limit entry exists (= unlimited)
 *   - `isUnlimited`: true when the plan has no entry or limit_value === -1
 *   - `isLoading`: whether subscription data is still loading
 */
export function usePlanLimit(key: string): {
  limit: number | null
  isUnlimited: boolean
  isLoading: boolean
} {
  const { data, isLoading } = useSubscription()

  if (isLoading) return { limit: null, isUnlimited: true, isLoading: true }

  const limits = data?.plans?.plan_limits ?? []
  const entry = limits.find((l) => l.limit_key === key)

  if (!entry || entry.limit_value === -1) {
    return { limit: null, isUnlimited: true, isLoading: false }
  }

  return { limit: entry.limit_value, isUnlimited: false, isLoading: false }
}
